
import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import { ProductionLogService } from './production-log.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { BillGenerationReportRequest, BillNumberRequest, DegummingLogReq, DegummingOutputLogReq, DegummingReq, JobReportingInfoReq, LotNumberReportResponseModel, prodOpCreateReq, prodOpOutputReq, prodOpReq, prodOpViewReq, ProductionLogDetailsResponseModel, ProductionLogResponse, ProductionProcessDashboardReq, ReportingInfoResponseModel, SpsaProdViewResponseModel, SubPlantTransferResponse, TransportChargesReq, WorkOrderLogReq } from '@gtpl/shared-models/production-management';
import { ProductionLogData } from './dto/production-log.dto';
import { LogIdRequest } from './dto/log-id-request';
import { LotInfoRequest } from './dto/lot-info.request';
import { UnitRequest } from './dto/unit.id.request';
import { CommonResponse } from '@gtpl/shared-models/masters';


@ApiTags('prod-log')
@Controller('prod-log')
export class ProductionLogController {
    constructor(
        private productionLogService: ProductionLogService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    
    @Post('/createProdLog')
    async createProdLog(@Body() prodLogDto: ProductionLogData): Promise<ProductionLogResponse> {
    try {
        return await this.productionLogService.CreateProductionLog(prodLogDto);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(ProductionLogResponse, error);
      }
    }

    @Post('/getLogDetailsForId')
    async getLogDetailsForId(@Body() prodLogDto: LogIdRequest): Promise<SubPlantTransferResponse> {
    try {
        return await this.productionLogService.getLogDetailsForId(prodLogDto.productionLogid);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(SubPlantTransferResponse, error);
      }
    }
    @Post('/getLotTrackingReportData')
  async getLotTrackingReportData(@Body() req: LotInfoRequest): Promise<LotNumberReportResponseModel> {
    try {
      return await this.productionLogService.getLotTrackingReportData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotNumberReportResponseModel, error);
    }
  }
    @Post('/getSubPlantHistoryDetails')
  async getSubPlantHistoryDetails(@Body() req: UnitRequest): Promise<ProductionLogDetailsResponseModel> {
    try {
      return await this.productionLogService.getSubPlantHistoryDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ProductionLogDetailsResponseModel, error);
    }
  }

  @Post('/getTransactionDetails')
  async getTransactionDetails(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getTransactionDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAllReportingInfo')
  async getAllReportingInfo(@Body() req:JobReportingInfoReq):Promise<ReportingInfoResponseModel>{
    try{
      return await this.productionLogService.getAllReportingInfo(req);
    }catch(error){
      return this.applicationExceptionHandler.returnException(ReportingInfoResponseModel, error)
    }

  } 

  @Post('/getLotNumberDetails')
  async getLotNumberDetails():Promise<CommonResponse>{
    try{
      return await this.productionLogService.getLotNumberDetails();
    }catch(err){
      return this.applicationExceptionHandler.returnException(CommonResponse, err)
    }
  }

  @Post('getIntakeDetailsForProductionDashboard')
  async getIntakeDetailsForProductionDashboard(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getIntakeDetailsForProductionDashboard(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getSoakingDataForProductionReport')
  async getSoakingDataForProductionReport(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getSoakingDataForProductionReport(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getShiftWiseDataForProductionReport')
  async getShiftWiseDataForProductionReport(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getShiftWiseDataForProductionReport(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getTotalProductionForDashboard')
  async getTotalProductionForDashboard(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getTotalProductionForDashboard(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getValueAdditionQuantitiesForProduction')
  async getValueAdditionQuantitiesForProduction(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getValueAdditionQuantitiesForProduction(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getValueAdditionFourForProduction')
  async getValueAdditionFourForProduction(@Body() req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getValueAdditionFourForProduction(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getBillInfoByBillNumber')
  async getBillInfoByBillNumber(@Body() req?:BillNumberRequest):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getBillInfoByBillNumber(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getWorkersInfoByBillNumber')
  async getWorkersInfoByBillNumber(@Body() req:BillNumberRequest):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getWorkersInfoByBillNumber(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getDistinctBillNumber')
  async getDistinctBillNumber(@Body() req:BillNumberRequest):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getDistinctBillNumber(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  
  @Post('getDistinctContractorName')
  async getDistinctContractorName(@Body() req:BillNumberRequest):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getDistinctContractorName(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getContractorwiseBillGeneration')
  async getContractorwiseBillGeneration(@Body() req?:BillGenerationReportRequest):Promise<CommonResponse>{
      try{
          return await this.productionLogService.getContractorwiseBillGeneration(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('wagesPayableVillageWise')
  async wagesPayableVillageWise(@Body() req?: TransportChargesReq):Promise<CommonResponse>{
      try{
          return await this.productionLogService.wagesPayableVillageWise(req);
      }catch(error){
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/getContractorAndDayWiseData')
  async getContractorAndDayWiseData(@Body() req?: TransportChargesReq): Promise<CommonResponse> {
      try {
          return await this.productionLogService.getContractorAndDayWiseData(req);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
      }
  }

      @Post('/createLogForWorkOrder')
  async createLogForWorkOrder(@Body() req: WorkOrderLogReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.createLogForWorkOrder(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

        @Post('/createLotCodeForExportBales')
  async createLotCodeForExportBales(@Body() req: WorkOrderLogReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.createLotCodeForExportBales(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

          @Post('/getWorkOrderNoForDegumming')
  async getWorkOrderNoForDegumming(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getWorkOrderNoForDegumming();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

          @Post('/getProductIdByWorkOrderNo')
  async getProductIdByWorkOrderNo(@Body() req?: DegummingReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getProductIdByWorkOrderNo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

          @Post('/getQualityForDegumming')
  async getQualityForDegumming(@Body() req?: DegummingReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getQualityForDegumming(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

            @Post('/getWOQtyForDegumming')
  async getWOQtyForDegumming(@Body() req?: DegummingReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getWOQtyForDegumming(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

       @Post('/createLogForDegumming')
  async createLogForDegumming(@Body() req: DegummingLogReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.createLogForDegumming(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

              @Post('/getDegummingQtyForDegumming')
  async getDegummingQtyForDegumming(@Body() req?: DegummingReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getDegummingQtyForDegumming(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

                @Post('/createLogForOutputDegumming')
  async createLogForOutputDegumming(@Body() req?: DegummingOutputLogReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.createLogForOutputDegumming(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

            @Post('/getOpenLWorkOrdersForDegumming')
  async getOpenLWorkOrdersForDegumming(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getOpenLWorkOrdersForDegumming();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

              @Post('/getOpenVariantForDegumming')
  async getOpenVariantForDegumming(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getOpenVariantForDegumming();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

              @Post('/getQualityVariantForDegumming')
  async getQualityVariantForDegumming(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getQualityVariantForDegumming();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

                @Post('/getDegummingOutProducts')
  async getDegummingOutProducts(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getDegummingOutProducts();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

                  @Post('/getClosedDegummingData')
  async getClosedDegummingData(@Body() req?: DegummingReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getClosedDegummingData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

   @Post('/getLotNoForProdOp')
  async getLotNoForProdOp(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getLotNoForProdOp(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

     @Post('/createLogForProdOp')
  async createLogForProdOp(@Body() req?: prodOpReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.createLogForProdOp(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

       @Post('/getQtyInfoForInputProdOp')
  async getQtyInfoForInputProdOp(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getQtyInfoForInputProdOp(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

         @Post('/getDataAgainstLotForProdOp')
  async getDataAgainstLotForProdOp(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getDataAgainstLotForProdOp(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

           @Post('/getProdOpInputData')
  async getProdOpInputData(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getProdOpInputData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

             @Post('/createOutputProdOp')
  async createOutputProdOp(@Body() req?: prodOpOutputReq[]): Promise<CommonResponse> {
    try {
      return await this.productionLogService.createOutputProdOp(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

             @Post('/getPrevOPOutputProduct')
  async getPrevOPOutputProduct(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getPrevOPOutputProduct(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
             @Post('/getOperationForInputProd')
  async getOperationForInputProd(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getOperationForInputProd();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
             @Post('/getPrevOperationForInputProd')
  async getPrevOperationForInputProd(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getPrevOperationForInputProd();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
             @Post('/getLotForInputProd')
  async getLotForInputProd(): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getLotForInputProd();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

     @Post('/getPrevOpOutputCount')
  async getPrevOpOutputCount(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getPrevOpOutputCount(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

     @Post('/getPrevOpOutputCountType')
  async getPrevOpOutputCountType(@Body() req?: prodOpCreateReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getPrevOpOutputCountType(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

       @Post('/getProdOpViewData')
  async getProdOpViewData(@Body() req?: prodOpViewReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getProdOpViewData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
       @Post('/getOperationsForProdView')
  async getOperationsForProdView(@Body() req?: prodOpViewReq): Promise<CommonResponse> {
    try {
      return await this.productionLogService.getOperationsForProdView(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
}